/**
 * Created by Ninghai on 2017/12/19.
 * Modify by zhaoweizhang on 2018/12/19.
 */
import { JOB_LIST, FACTOR_TYPE, EMOTION_DETAILS, STOCK_DETAILS, RETAILERS, RETAILERS_TOP, LIVE_DATA ,BRAND_DATA} from './mutation-types'
import { jobList, getEmotionParameter, getEmotionDetails, getRetailers, getlive,getBrand } from '../services/getData'
import router from '../router/index'

export default {
  async getJobList ({commit}, state) {
    let res = await jobList()
    commit(JOB_LIST, res)
  },
  async getEmotionParameterAction({commit}) {
    let res = await getEmotionParameter()
    if(res.code !== 0) {
      router.push('/login')
    } else {
      commit(FACTOR_TYPE, res.data.retail)
    }
  },
  async getEmotionDetailAction({commit}, payload) {
    let res = await getEmotionDetails(payload);
    if(res.code === 1001) {
      alert('您没有权限！')
      return;
    } else {
      if(payload.table === 'retail.individual_stock.menu') {
        commit (EMOTION_DETAILS, res.data)
      } else {
        commit (STOCK_DETAILS, res.data)
      }
    }
  },
  /**
   * 电商标准化
   */
  async getRetailersAction({commit}, payload) {
    let res = await getRetailers(payload);
    commit (RETAILERS, res.data)
  },
  //电商标准化头部只展示最后一天的信息
  async getRetailersHeadAction({commit}, payload) {
    let res = await getRetailers(payload);
    if(res.code === 1002) {
      alert(res.msg);
      setTimeout(()=>{
        router.push('/login')
      },1000)
    } else if(res.code === 1001) {
      alert(res.msg)
    } else {
      commit (RETAILERS_TOP, res.data)
    }
  },
  /** 
   * 直播标准化
  */
 async getLive({commit},payload) {
   let res = await getlive(payload);
   if(res.code === 1002) {
      alert(res.msg);
      setTimeout(()=>{
        router.push('/login')
      },1000)
    } else if(res.code === 1001) {
      alert(res.msg)
    } else {
      commit (LIVE_DATA, res.data)
    } },

    // 品牌馆
    async getBrandAction({commit}, payload){
      let res = await getBrand(payload);
      commit (BRAND_DATA, res.data)

    }

    //    15万天猫
      


  }
  
  



// WEBPACK FOOTER //
// ./src/store/actions.js